import Api from "..";

const getAusencias = async () => {
    try {
        const response = await Api.get("ausencia/listarAusencias");
        return response.data || [];
    } catch (error) {
        throw new Error(`Erro ao buscar ausências: ${error.message}`);
    }
};

export default {
    getAusencias,
};
